import { encode } from "utils/HelperFunctions";
import { decodeAndValidatePublicLink } from "utils/publicLinkValidation";
import type { PostLoginRoute } from "utils/postLoginRoute";

export type PaymentActionType = "failed" | "re-auth";

export type PaymentActionRoute = {
  clusterId: string;
  clusterSlug: string;
  loginPath: string;
  postLoginRoute: PostLoginRoute;
};

export const isPaymentActionType = (
  type: string | null | undefined
): type is PaymentActionType => type === "failed" || type === "re-auth";

export const getPaymentActionRoute = (
  type: string | null | undefined,
  id: string | null | undefined
): PaymentActionRoute | null => {
  if (!isPaymentActionType(type) || !id) {
    return null;
  }

  // Both action links currently carry the payment's public pid_ slug.
  const publicLink = decodeAndValidatePublicLink(id, "pid_");
  if (!publicLink) {
    return null;
  }

  const clusterSlug = encode(publicLink.clusterId, "ci_");
  const search = new URLSearchParams({
    drawer: "open",
    paymentActionType: type,
    paymentActionId: id,
  });

  return {
    clusterId: publicLink.clusterId,
    clusterSlug,
    loginPath: `/${clusterSlug}/login`,
    postLoginRoute: {
      pathname: `/${clusterSlug}/payments`,
      search: `?${search.toString()}`,
      clusterId: publicLink.clusterId,
    },
  };
};
